// extracted by mini-css-extract-plugin
export default {"item-list":"BeersDesktop_item-list__o4Juo","item":"BeersDesktop_item__JB1Y6","section":"BeersDesktop_section__1cRwZ"};